"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRAPHQL_EVENTS = void 0;
var bernie_logger_1 = require("bernie-logger");
exports.GRAPHQL_EVENTS = {
    GRAPHQL_SERVICE_ERROR: new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.ERROR, 'GRAPHQL_SERVICE_ERROR'),
    GRAPHQL_NETWORK_ERROR: new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.ERROR, 'GRAPHQL_NETWORK_ERROR')
};
//# sourceMappingURL=events.js.map